function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 6h18",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 6h1a1 1 0 00-1-1v1zM5 6V5a1 1 0 00-1 1h1zm3 0H7a1 1 0 001 1V6zm8 0v1a1 1 0 001-1h-1zm2 0v14h2V6h-2zm0 14a1 1 0 01-1 1v2a3 3 0 003-3h-2zm-1 1H7v2h10v-2zM7 21a1 1 0 01-1-1H4a3 3 0 003 3v-2zm-1-1V6H4v14h2zM19 5H5v2h14V5zM9 6V4H7v2h2zm0-2a1 1 0 011-1V1a3 3 0 00-3 3h2zm1-1h4V1h-4v2zm4 0a1 1 0 011 1h2a3 3 0 00-3-3v2zm1 1v2h2V4h-2zM8 7h8V5H8v2z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 11v6M14 11v6",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgIconTrash;